export const INPUT_VALUE_TEXT_COLOR = '#696F88';
export const INPUT_FONT_SIZE = '14px';
export const INPUT_TYPOGRAPHY_SX = {
    '& .MuiInputLabel-root': {
        fontSize: INPUT_FONT_SIZE,
    },
    '& .MuiOutlinedInput-notchedOutline': {
        fontSize: INPUT_FONT_SIZE,
    },
    '& .MuiInputBase-input': {
        fontSize: INPUT_FONT_SIZE,
        color: INPUT_VALUE_TEXT_COLOR,
    },
    '& .MuiInputBase-input::placeholder': {
        fontSize: INPUT_FONT_SIZE,
        color: INPUT_VALUE_TEXT_COLOR,
        opacity: 1,
    },
};
